import React, { useContext } from "react";
import ContextApi from "../../context/ContextApi";
import "../../stylesheet/forms.css";
import {
  addPatient,
  editPatient,
  getSelectedPatient,
} from "../../Utils/localStore";

export default function PatientSummary(props) {
  const {
    patientName,
    gender,
    email,
    contactDetails,
    address,
    age,
    pulse,
    weight,
    height,
    systolic,
    diastolic,
    temperature,
    sugarLevel,
    insuranceProvider,
    insuranceNumber,
    hospitalized,
    doctorcare,
    medication,
    allergies,
    hereditary,
    bloodGroup,
    smoker,
    drinker,
    gainedWeight,
    pregnant,
    preExistingCondition,
    responsibleDepartment,
    assignedPersonnel,
    appointmentFrequency,
    startDate,
    endDate,
    startTime,
    endTime,
    sessionType,
  } = useContext(ContextApi);

  const setNewPatient = () => {
    const newPatient = {
      patientName,
      gender,
      email,
      contactDetails,
      address,
      age,
      pulse,
      weight,
      height,
      systolic,
      diastolic,
      temperature,
      sugarLevel,
      insuranceProvider,
      insuranceNumber,
      hospitalized,
      doctorcare,
      medication,
      allergies,
      hereditary,
      bloodGroup,
      smoker,
      drinker,
      gainedWeight,
      pregnant,
      preExistingCondition,
      responsibleDepartment,
      assignedPersonnel,
      appointmentFrequency,
      startDate,
      endDate,
      startTime,
      endTime,
      sessionType,
    };
    return newPatient;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newPatient = { ...setNewPatient() };
    newPatient.status = "Active";
    let today = Date.now();
    const formatter = new Intl.DateTimeFormat([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    today = formatter.format(today);
    newPatient.joinedDate = today;
    newPatient.synced = false;
    await addPatient(newPatient);
    props.onSubmit();
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    const selectedPatientData = await getSelectedPatient().then(
      (resp) => resp[0]
    );
    const newPatient = { ...selectedPatientData, ...setNewPatient() };
    const resp = await editPatient(newPatient).then((resp) => {
      if (resp) console.log("update, done");
    });
    props.onSubmit();
  };
  return (
    <div className="">
      <div className="">
        <h1 className="text-sky-500 text-3xl mt-10 font-bold ">
          Patient Summary
        </h1>
        <p className="pt-4">
          Review all patient information before confirming entry.
        </p>
      </div>

      <div className="flex justify-center flex-col-reverse lg:flex-row p-4 lg:p-0 gap-5">
        <div className="w-full lg:w-4/5 h-[470px] overflow-y-auto mt-8 summary-steps">
          <div className="">
            <h1 className="font-bold mb-3">Patient Details</h1>
            <div className="border border-gray-400 rounded-md lg:w-[550px] p-3">
              <div>
                <h4 className="text-gray-400">Name: </h4>
                <p>{patientName}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Email address:</h4>
                <p> {email}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Phone number: </h4>
                <p>{contactDetails}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Residential address:</h4>
                <p> {address}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Gender: </h4>
                <p>{gender}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Age : </h4>
                <p>{age}</p>
              </div>
              <div>
                <h4 className="text-gray-400 mt-4">Blood Group : </h4>
                <p>{bloodGroup}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Pulse(bpm): </h4>
                <p>{pulse}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Weight (kg): </h4>
                <p>{weight}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Height (cm): </h4>
                <p>{height}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Systolic/Diastolic (mmHg):{" "}
                </h4>
                <p>{systolic}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Systolic/Diastolic (mmHg):{" "}
                </h4>
                <p>{diastolic}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Sugar level (mg/dL): </h4>
                <p>{sugarLevel}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Temperature (oC): </h4>
                <p>{temperature}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Insurance provider : </h4>
                <p> {insuranceProvider}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Insurance number : </h4>
                <p>{insuranceNumber}</p>
              </div>
            </div>

            <h1 className="font-bold mb-3 mt-5">Medical History</h1>
            <div className="border border-gray-400 rounded-md lg:w-[550px] p-3">
              <div>
                <h4 className="text-gray-400">
                  Hospitalized, operated or serious illness in the past 3 years?
                </h4>
                <p>{hospitalized}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Under doctor's care in the past 3 years?
                </h4>
                <p> {doctorcare}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Administered medication in the past 6 months?
                </h4>
                <p>{medication}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Any allergies?</h4>
                <ul>
                  {allergies.map((item) => (
                    <li key={item.tag}>{item.tag}</li>
                  ))}
                </ul>
                {/* <p>{allergies}</p> */}
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Any hereditary conditions?
                </h4>
                {/* <p>{hereditary}</p> */}
                <ul>
                  {hereditary.map((item) => (
                    <li key={item.tag}>{item.tag}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Doctor's Care?</h4>
                <p>{doctorcare}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Drinker?</h4>
                <p>{drinker}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Smoker?</h4>
                <p>{`${smoker}`}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Gained or lost 10kg in the last year?
                </h4>
                <p>{gainedWeight}</p>
              </div>

              {gender === "female" && (
                <div>
                  <h4 className="text-gray-400 mt-4">Pregnant ?</h4>
                  <p>{pregnant}</p>
                </div>
              )}

              <div>
                <h4 className="text-gray-400 mt-4">
                  Pre-existing conditions?{" "}
                </h4>
                <ul>
                  {preExistingCondition.map((item) => (
                    <li key={item.tag}>{item.tag}</li>
                  ))}
                </ul>
              </div>
            </div>

            <h1 className="font-bold mb-3 mt-5">Appointment & Delegation</h1>
            <div className="border rounded-md lg:w-[550px] mb-24 p-3">
              <div>
                <h4 className="text-gray-400">Responsible department</h4>
                <ul>
                  {responsibleDepartment.length > 0 &&
                    responsibleDepartment.map((item) => (
                      <li key={item.tag}>{item.tag}</li>
                    ))}
                </ul>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Assigned personnel</h4>
                <p>{assignedPersonnel}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Appointment frequency</h4>
                <p>{appointmentFrequency}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Start date</h4>
                <p>{startDate}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">End date</h4>
                <p>{endDate}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Start time</h4>
                <p>{startTime}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">End time</h4>
                <p>{endTime}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Session type</h4>
                <p>{sessionType}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/5">
          <div className="mt-3">
            <button
              className="border-sky-600 border text-sky-500 mb-4 p-2 w-36 rounded"
              onClick={props.onBack}
            >
              {localStorage.getItem("patientEditMode") === "true"
                ? "Edit"
                : "Back"}
            </button>
            <div>
              {localStorage.getItem("patientEditMode") === "true" ? (
                <button
                  className="bg-sky-600 text-white mb-4 p-2 w-36 rounded"
                  onClick={(e) => handleUpdate(e)}
                >
                  Update
                </button>
              ) : (
                <button
                  className="bg-sky-600 text-white mb-4 p-2 w-36 rounded"
                  onClick={(e) => handleSubmit(e)}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
